import { useState } from 'react';
import { CheckCircle, Loader2 } from 'lucide-react';
import { KordaroLogo, KordaroMark } from '../../core/shared/components/KordaroLogo.js';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.message);
      }
      setSent(true);
    } catch (err: any) {
      setError(err.message || 'Er is een fout opgetreden');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-surface flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4"><KordaroLogo width={200} /></div>
          <h1 className="text-2xl font-bold text-gray-900">Wachtwoord vergeten</h1>
          <p className="text-gray-500 mt-1">Vul je e-mailadres in om een resetlink te ontvangen</p>
        </div>

        <div className="bg-card border border-card-border rounded-[14px] p-8 shadow-sm">
          {sent ? (
            <div className="text-center">
              <CheckCircle className="h-12 w-12 text-green-500 mx-auto mb-4" />
              <h2 className="text-lg font-semibold text-gray-900 mb-2">Email verstuurd!</h2>
              <p className="text-gray-500 text-sm mb-6">
                Als dit e-mailadres bij ons bekend is, ontvang je binnen enkele minuten een link om je wachtwoord te resetten.
              </p>
              <a href="/" className="inline-block w-full py-2.5 px-4 bg-gold hover:bg-gold-dark text-white font-medium rounded-lg transition-colors text-center">
                Terug naar inlogpagina
              </a>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              {error && (
                <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
                  {error}
                </div>
              )}
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-1">E-mailadres</label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold/50 focus:border-gold"
                  placeholder="naam@bedrijf.be"
                  required
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="w-full py-2.5 px-4 bg-gold hover:bg-gold-dark text-white font-medium rounded-lg transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
              >
                {loading ? <><Loader2 className="h-4 w-4 animate-spin" /> Versturen...</> : 'Resetlink versturen'}
              </button>
              <p className="text-center text-sm text-gray-500 mt-4">
                <a href="/" className="text-gold font-medium hover:underline">Terug naar inloggen</a>
              </p>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
